import styled from 'styled-components'

export const NotifyWrapper = styled.div`
position: fixed;
top: -100px;
left: 0;
width: 100%;
display: flex;
justify-content: center;
transition: top 300ms ease-out;
z-index: 20000;
&.open {
  top: 25px;
  color: white;
  transition: top 300ms ease-in;
}
&.error {
  &>div {
      background-color: #DA4C4C;
  }
}
&.success {
  &>div {
      background-color: #49af46;
  }
}
&>div {
  color: white;
  padding: 1rem 3rem;
  border-radius: 8px;
  background-color: #3F76E6;
  background-color: limegreen;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;

}
`;

export const Notifier = ({ open, data }) => (
  <NotifyWrapper className={`${data?.type} ${open ? 'open': ''}`}>
    <div>
      {data?.message}
    </div>
  </NotifyWrapper>
)

export default Notifier
